import React, { useEffect, useState } from "react";
import { ImagePath } from "../../../assets/ImagePath";
import Register from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";
import { getDomainConfig } from "../../../utils/DomainsHelper";


const SignupPage = () => {
  const [bgImage, setBgImage] = useState("");
  useEffect(() => {
   const config = getDomainConfig();
    setBgImage(config.banner);
  },[])
  return (
    <AuthLayout
      LeftComponent={Register}
      rightBgImage={bgImage}
    />
  );
};

export default SignupPage;